// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"115037ce","160":"61f90f8e","208":"d7e24d6c","293":"cb1ed739","453":"b0cd7502","516":"70065aaa","519":"20d1266a","906":"dd07301b","917":"4cf71a85","946":"f8c40005"}[chunkId] + ".chunk.js";
};